
@switch (sectionType) {
  <!-- Metadata Section -->
  @case ('metadata') {
    <div class="metadata-grid">
      @for (item of metadataColumns; track item) {
        <div class="metadata-item">
          <strong>{{ item.title }}:</strong>
          <app-dynamic-cell
            [schema]="item.schema"
            [value]="getValue(data, item.key)">
          </app-dynamic-cell>
        </div>
      }
    </div>
  }
  <!-- Table Section -->
  @case ('table') {
    <app-report-builder
      [schema]="childSchema"
      [data]="data">
    </app-report-builder>
  }
}
